import { render } from "./user-info.vue?vue&type=template&id=de8bae4c&scoped=true&ts=true"
import script from "./user-info.vue?vue&type=script&lang=ts"
export * from "./user-info.vue?vue&type=script&lang=ts"

import "./user-info.vue?vue&type=style&index=0&id=de8bae4c&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8bae4c"]])